import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const MasterApi = createApi({
  reducerPath: "MasterApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["MasterApi"],
  endpoints: (build) => ({
    getDistrict: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=district`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),
    getZone: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=zoneoffice`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),

    getTaluk: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=taluk`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),

    getDesignation: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=designation`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),

    getDeeOffice: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=deeoffice`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),

    getComplaints: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=complaints`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),
    getFlyingSquad: build.mutation({
      query: (data) => ({
        url: `/master.php?VALUE=flyingsquad`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MasterApi"],
    }),
  }),
});

export const {
  useGetDistrictMutation,
  useGetTalukMutation,
  useGetDesignationMutation,
  useGetDeeOfficeMutation,
  useGetComplaintsMutation,
  useGetFlyingSquadMutation,
  useGetZoneMutation,
} = MasterApi;
